/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import EventDispatcher = alm.event.EventDispatcher;

	export class PhotoTextureLoader extends EventDispatcher {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super();

			this.isLoading = false;
			this.isSuccess = false;
			this.isFailure = false;

			this.lastErrorEvent = null;

			//this.stats = jQuery('#loading-photo-texture');
			//this.setStatsBlink(false);
			//this.hideStats(false);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public load():void {
			if (this.isLoading) return;
			this.isLoading = true;

			this.calcParameters();
			this.loadNextLevel();
		}

		private loadNextLevel():void {
			if (this.parameters.length == 0) {
				this.isFailure = true;
				trace('[PhotoTextureLoader] load error');
				//this.setStatsText('該当の活動日記では航空写真モードは利用できません');
				//this.showStats();
				this.dispatchEvent(new PhotoTextureLoaderEvent(PhotoTextureLoaderEvent.ERROR, this, null, null, this.lastErrorEvent));
				return;
			}

			const parameter = this.parameters.pop();
			const baseUrl = Config.useDevServer ? 'https://tile-api-dev.yamap.com/' : 'https://tile-api.yamap.com/';
			const url = baseUrl + 'proxy/xyz/seamlessphoto/' + parameter.zoomLevel + '/' + parameter.from[0] + '-' + parameter.from[1] + '...' + parameter.to[0] + '-' + parameter.to[1];
			trace('[PhotoTextureLoader] load : zoom level =', parameter.zoomLevel, ', url =', url);

			this.loader = new THREE.TextureLoader();
			this.loader.crossOrigin = 'anonymous';
			this.loader.load(url, (texture:THREE.Texture):void => {
				this.texture = texture;
				this.isSuccess = true;
				trace('[PhotoTextureLoader] load success');
				//this.setStatsText('TEXTURE LOAD COMPLETE');
				//this.hideStats();
				this.dispatchEvent(new PhotoTextureLoaderEvent(PhotoTextureLoaderEvent.COMPLETE, this, this.texture, null, null));

			}, (event:ProgressEvent):void => {
				//this.setStatsText('TEXTURE LOADING...');
				this.dispatchEvent(new PhotoTextureLoaderEvent(PhotoTextureLoaderEvent.PROGRESS, this, null, event, null));

			}, (event:ErrorEvent):void => {
				this.lastErrorEvent = event;
				this.loadNextLevel();
			});
		}

		private calcParameters():void {
			const meta = AssetLoader.getInstance().getMeta();

			const defaultZoomLevel = meta.getZoomLevel();
			const defaultFromX = meta.getTileTopLeft().x;
			const defaultFromY = meta.getTileTopLeft().y;
			const defaultToX = meta.getTileBottomRight().x;
			const defaultToY = meta.getTileBottomRight().y;

			let customZoomLevel = defaultZoomLevel;
			let customFromX = defaultFromX;
			let customFromY = defaultFromY;
			let customToX = defaultToX;
			let customToY = defaultToY;

			const targetResolution = Config.photoTextureTargetResolution;
			trace('[PhotoTextureLoader] target resolution =', targetResolution);

			const maxZoomLevel = Config.photoTextureMaxZoomLevel;
			trace('[PhotoTextureLoader] max zoom level =', maxZoomLevel);

			let deltaZoom = 0;
			this.parameters = [];

			while (true) {
				this.parameters.push({ zoomLevel: customZoomLevel, from: [customFromX, customFromY], to: [customToX, customToY] });
				trace('[PhotoTextureLoader] add parameter : zoom level =', customZoomLevel, ', from = (', customFromX, ',', customFromY, '), to =', customToX, ',', customToY,  ')');

				++deltaZoom;
				customZoomLevel = defaultZoomLevel + deltaZoom;

				if (customZoomLevel <= maxZoomLevel) {
					customFromX = this.getFromDeltaZoomTilePosition(defaultFromX, deltaZoom);
					customFromY = this.getFromDeltaZoomTilePosition(defaultFromY, deltaZoom);
					customToX = this.getToDeltaZoomTilePosition(defaultToX, deltaZoom);
					customToY = this.getToDeltaZoomTilePosition(defaultToY, deltaZoom);

					const from = Unit.tileToLatLng(customFromX, customFromY, customZoomLevel); // top left
					from.calcPixelCoord(customZoomLevel);

					const to = Unit.tileToLatLng(customToX + 1, customToY + 1, customZoomLevel); // bottom right
					to.calcPixelCoord(customZoomLevel);

					const resolution = to.getPixel().x - from.getPixel().x;
					trace('[PhotoTextureLoader] test : zoom level =', customZoomLevel, ', resolution =', resolution);

					if (resolution > targetResolution) {
						break;
					}

				} else {
					break;
				}
			}
		}

		public getTexture():THREE.Texture {
			return this.texture;
		}

		public getIsLoading():boolean {
			return this.isLoading;
		}

		public getIsSuccess():boolean {
			return this.isSuccess;
		}

		public getIsFailure():boolean {
			return this.isFailure;
		}

		/*
		public showStats(useTransition:boolean = true):void {
			this.stats.css('display', 'block');
		}

		public hideStats(useTransition:boolean = true):void {
			this.stats.css('display', 'none');
		}

		public setStatsBlink(isBlink:boolean):void {
			if (isBlink) {
				this.stats.addClass('blink');
			} else {
				this.stats.removeClass('blink');
			}
		}

		private setStatsText(text:string):void {
			this.stats.text(text);
		}
		*/

		private getFromDeltaZoomTilePosition(position:number, deltaZoom:number):number {
			return deltaZoom > 0 ? (position * Math.pow(2, deltaZoom)) : position;
		}

		private getToDeltaZoomTilePosition(position:number, deltaZoom:number):number {
			return deltaZoom > 0 ? ((position + 1) * Math.pow(2, deltaZoom) - 1) : position;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isLoading:boolean;
		private isSuccess:boolean;
		private isFailure:boolean;
		private loader:THREE.TextureLoader;
		private texture:THREE.Texture;
		//private stats:JQuery;
		private parameters:{ zoomLevel:number, from:number[], to:number[] }[];
		private lastErrorEvent:ErrorEvent;
	}
}
